import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { db } from '../config/firebase';

export const adminService = {
  // 모든 사용자 목록 가져오기
  getAllUsers: async () => {
    try {
      const usersQuery = query(
        collection(db, 'users'),
        orderBy('createdAt', 'desc')
      );
      const querySnapshot = await getDocs(usersQuery);

      const users = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      return users;
    } catch (error) {
      console.error('Error fetching users:', error);
      throw new Error('사용자 목록을 가져오는데 실패했습니다.');
    }
  },
};
